
export const FORM_SUBMIT = 'it.lacele/FORM_SUBMIT'
export const FORM_FIELDS_VALUE = 'it.lacele/FORM_FIELDS_VALUE'
export const FORM_FIELD_REMOVE = 'it.lacele/FORM_FIELD_REMOVE'
